// extracted by mini-css-extract-plugin
module.exports = {"szqq4ic":"szqq4ic"};